import { OmitType } from '@nestjs/swagger/dist/type-helpers/omit-type.helper';
import { VacancyCreateRequest } from '@common/model/catalog/item/vacancyCreate.request';
import { CityViewModel } from '@common/model/location/cityViewModel';
import { LocationSuggestion } from '@common/model/location/locationSuggestion';

export const CITY_FIELD_NAME = 'city';
export const ADDRESS_FIELD_NAME = 'address';

export class FormModel extends OmitType(VacancyCreateRequest, ['address', 'location'] as const) {
  date?: string | null;
  [ADDRESS_FIELD_NAME]?: LocationSuggestion;
  [CITY_FIELD_NAME]: CityViewModel;
}
